<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="status_array_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Status Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Maintenance Status</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-select v-model="editedItem.name" label="Status" :items="status_super_master_list"
                            item-text="name" :disabled="editedIndex != -1" persistent-hint :hint="
                              editedIndex == -1
                                ? 'Select Maintenance Status :: Done, In-Process, Rejected, Cancelled'
                                : 'noneditable'
                            " :filled="editedIndex == -1 ? false : true" :error="errorMsg.name ? true : false"
                            :error-messages="errorMsg.name ? 'Required' : ''"
                            :rules="[(v) => !!v || 'required']"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" color="primary" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <!-- <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success"
              >mdi-check-circle-outline</v-icon
            >
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error"
              >mdi-close-circle-outline</v-icon
            >
          </span>
        </template> -->

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    // extraBreadcrumbItems: [
    //   { text: "Status Master", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style2",
    overlay: false,
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Status Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Status",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    status_array_list: [],
    status_super_master_list:[],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      name: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New status" : "Edit Status";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.status_array_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/MaintenanceSystem/getStatus")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.status_array_list = res.data.status_array_list;
            this.status_super_master_list = res.data.status_super_master_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/MaintenanceSystem/editStatus", this.editedItem)
            .then((res) => {
              if (res.data.code == "SUCCESS") {
                //window.alert(res.data.msg)
                // Object.assign(
                //   this.status_array_list[this.editedIndex],
                //   this.editedItem
                // );
                this.showSnackbar("#4caf50", "Status Updated Successfully..."); // show snackbar on success
                this.onLoad();
              } else {
                this.showSnackbar("#4caf50", "Something went wrong!");
                sessionStorage.setItem("error-trace", res.data.error_trace);
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        axios
          .post("/MaintenanceSystem/saveStatus", this.editedItem)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              // window.alert(res.data.status.code)
              // this.status_array_list.push(this.editedItem);
              this.showSnackbar("#4caf50", "Status Added Successfully..."); // show snackbar on success
              this.onLoad();
            } else if (res.data.code == "NA") {
              // window.alert(res.data.status.code)
              // alert(res.data.status.message)
              this.showSnackbar("#b71c1c", "Status Already Present!!!"); // show snackbar on error
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()
    isValidated() {
      if (this.editedItem.name) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }

        return false;
      }
    }, // .....end of isValidated()

    toggle(item) {
      const data = {
        status_id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/MaintenanceSystem/toggleStatus", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Status Changed!"); // show snackbar
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            ); // show snackbar
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>